module.exports = __webpack_public_path__ + "img/car02.df970a22.png";